import type { AsyncBelongsTo } from '@ember-data/model';
import Model, { attr, belongsTo } from '@ember-data/model';
import type FlowModel from 'garaje/models/flow';

// Values must match the backend `DataCategories::*` constants (envoy-web) — these
// are the keys the API uses in an entry/invite's `sensitiveFields` map.
export enum DataCategory {
  PHOTOS_AND_MEDIA = 'Photos and media',
  LEGAL_DOCUMENTS = 'Legal documents',
  SEARCH_TEXT = 'Search text',
  REQUIRED_DOCUMENTS = 'Required documents',
  ID_SCANS = 'ID scans',
  PRIVATE_NOTES = 'Private notes',
}

const ATTACHMENT_DATA_CATEGORIES = [
  DataCategory.REQUIRED_DOCUMENTS,
  DataCategory.LEGAL_DOCUMENTS,
  DataCategory.PHOTOS_AND_MEDIA,
  DataCategory.ID_SCANS,
];

class FieldSetting extends Model {
  /**
   * sign in field id sent up
   */
  @attr('number') declare signInFieldId: number | null;

  /**
   * determines if sign in field is locked to version
   */
  @attr('number') declare flowVersionId: number | null;

  /**
   * alternative send up field id or data category
   */
  @attr('string') declare dataCategory: DataCategory | null;
  /**
   * sign in field name
   */
  @attr('string') declare displayName: string;
  @attr('boolean') declare isSelected: boolean;

  @belongsTo('flow', { async: true, inverse: null }) declare flow: AsyncBelongsTo<FlowModel>;

  get isAttachment(): boolean {
    if (!this.dataCategory) return false;
    return ATTACHMENT_DATA_CATEGORIES.includes(this.dataCategory);
  }
}

export default FieldSetting;

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'field-setting': FieldSetting;
  }
}
